export async function fetchWithLocalCache(url, cacheKey, ttlMs = 60 * 60 * 1000) {
  const now = Date.now();

  // 1) Try cache first
  try {
    const raw = localStorage.getItem(cacheKey);
    if (raw) {
      const cached = JSON.parse(raw);
      if (cached && cached.data && typeof cached.ts === "number") {
        const age = now - cached.ts;
        if (age < ttlMs) {
          // Fresh cache: return immediately
          return { data: cached.data, fromCache: true };
        }
      }
    }
  } catch {
    // ignore cache parse errors
  }

  // 2) Fetch from network
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();

  // 3) Save cache
  try {
    localStorage.setItem(cacheKey, JSON.stringify({ ts: now, data }));
  } catch {
    // ignore quota issues
  }

  return { data, fromCache: false };
}
